<template>
    <section class="content-section">
        <a-step step="1" header="Angaben zum Tier" :leadin="leadin" />

        <a-form class="info-form form" ref="petForm">
             <div class="container form__upper">
                <div v-if="leadin.errorMessage.message" class="afterSendError">{{ leadin.errorMessage.message }}</div>
                <br v-if="leadin.errorMessage.message">
                <div class="form__section">
                    <div class="form__title">
                        <h2>Welches Tier möchten Sie versichern?</h2>
                    </div>
                    <div class="form__row">
                        <div class="form__group form--small100">
                            <div class="input-control">
                                <div class="wrapper">
                                    <a-checkbox id="cb-dog" img="vwo/dog.png" radio v-model="race" label="Hund" value="1" :size="16" v-on:check="setRace('1'); pushDataLayer('tierdaten', 'tierart', 'Hund')" required :disabled="leadin.isUDSelling"/>
                                </div>
                            </div>
                        </div>
                        <div class="form__group form--small100" v-if="!isHP">
                            <div class="input">
                                <div class="input-control">
                                    <div class="wrapper">
                                         <a-checkbox id="cb-cat" img="vwo/cat.png" radio v-model="race" label="Katze" value="2" :size="16" v-on:check="setRace('2'); pushDataLayer('tierdaten','tierart', 'Katze')" required :disabled="leadin.isUDSelling"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="form__section">
                    <div class="form__title form_title_less">
                        <h2>Angaben zum Tier</h2>
                    </div>
                  <div class="fieldset">
                       <a-input label="Rasse" v-model="breed" type="select" :options="registry.breedList" required :rules="[rules.notEmpty]" @blur="pushDataLayer('tierdaten', 'rasse', $event.value)" :readonly="leadin.isUDSelling"/>
                        <a-input label="Geburtsdatum" :race="String(race)" v-model="petbirthday" type="date" required :eclass="leadin.errorMessage.petbirthday" :rules="ageRule" :yeartype="yeartype"  :readonly="leadin.isUDSelling" v-on:input="pushDataLayer('tierdaten','alter', calculateAge(petbirthday))" />
                    </div>
                    <div class="fieldset">
                        <a-input label="Geschlecht" v-model="petgender" type="select" :options="registry.petGender" required :rules="[rules.notEmpty]" @blur="pushDataLayer('tierdaten', 'geschlecht', $event.value)" :readonly="leadin.isUDSelling"/>
                        <a-input label="Fellfarbe " v-model="petcolour" type="select" :options="registry.colourList" required :rules="[rules.notEmpty]" @blur="pushDataLayer('tierdaten', 'fellfarbe', $event.value)" :readonly="leadin.isUDSelling"/>
                    </div>
                    <div class="fieldset">
                        <a-input required label="Rufname des Haustiers" v-model="petname" :rules="[rules.notEmpty, rules.toLong]" :readonly="leadin.isUDSelling" @blur="pushDataLayer('tierdaten','rufname', petname)"/>
                    </div>
                </div>
                <!-- 24-block end -->
            </div>

            <div class="form__links">
                <div class="container">
                    <div class="form__btn">
                        <div class="form__btn-holder">
                            <a-btn primary dark @click="submitBottom" class="btn btn--green">Weiter</a-btn>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
        </a-form>
    </section>
</template>

<script>
//const ga = window.ga
import {entryChannel, setEntryChannel} from "@/vars";
import {puppyEntry, setPuppy} from "../vars";

export default {
    model: {
        prop: 'leadin',
        event: 'leademit'
    },
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        leadin: {
            type: Object,
            default() {
                return {}
        }}
    },
    data: () => ({
        test: false,
        race: '1',
        petbirthday: '',
        petname: '',
        petgender: '1',
        petcolour: '',
        breed: '',
        breedList: [],
        isHP: false,
        noCat: false,
        hidden: true,
        health: '1',
        chronic: '0',
        respiratory: '0',
        healthDescription: '',
        hasNoRespiratory: false,
        finished: 0,
        file: '',
        fileInfo: {},
        isTK:false,
        isOP: false,
        showNewHealthBlock: false,
        healthCounter: 0,
        documentUploadText: "Dokument hochladen",
        rules: {
            notEmpty: function(v) {return v && !null? true: 'Darf nicht leer sein!'},
            toLong: function(v) {return v && v.length < 30? true: "Die Eingabe ist zu lang"},
            toYoung: function(v) {return v?"Das Tier ist zu jung.":"Das Tier ist zu jung."},
            toOld24: function(v) {return v?"Das Tier darf nicht älter als vier Jahre sein":"Das Tier darf nicht älter als vier Jahre sein"},
            toOld: function(v) {return v?"Das Tier darf nicht älter als acht Jahre sein":"Das Tier darf nicht älter als acht Jahre sein"},
            toOldCat: function(v) {return v?"Das Tier darf nicht älter als neun Jahre sein":"Das Tier darf nicht älter als neun Jahre sein"},
            toOldHP: function(v) {return v?"Das Tier darf nicht älter als zwanzig Jahre sein":"Das Tier darf nicht älter als zwanzig Jahre sein"},
            noFile: (v) => {return v?true:"Sie müssen Ihre Bestätigung hochladen."},
            noClick: (v) => {return v?true:"Sie müssen Ja oder Nein anklicken"},
            monthPattern: (v) => {
                const reg = /[0-1]{1}[0-9]{1}\/[1-2]{1}[0-9]{3}/
                if (reg.test(v) === true) {
                    return true
                }
                else {
                    return "Ihre Eingabe muss dem Muster MM/YYYY (z.B. 01/2017) folgen"
                }
            },
        }
    }),
    watch: {
        leadin: {
            immediate: true,
            handler (to) {
                this.race = to.race

                this.petbirthday = to.petbirthday
                this.petname = to.petname
                this.petgender = to.petgender
                this.petcolour = to.petcolour
                this.breed = to.breed
                this.health = (to.health !== undefined)? to.health: this.health;
                this.chronic = (to.chronic !== undefined)? to.chronic: this.chronic
                this.respiratory = (to.respiratory !== undefined)? to.respiratory: this.respiratory
                this.healthDescription = (to.healthDescription !== undefined)? to.healthDescription: this.healthDescription
                this.hidden = (to.hidden !== undefined)? to.hidden: this.hidden
                this.file = to.file
                this.fileInfo = to.fileInfo
            }
        },
    },
    mounted: function() {
        const brokerList = []//["1195114", "1606686", "1616388", "1656095", "999", "99901", "1595114"]

        if ((this.leadin.productActive == 1 || this.leadin.productActive == 2 || this.leadin.productActive == 4) && !brokerList.includes(this.leadin.brokerID) && this.leadin.tm == false) {


            this.isTK = true;

            this.$watch('finished', () => {
                this.finished = 1;
                //this.documentUploadText = 'Datei wurde hochgeladen'
            })
        }

        if ((this.leadin.productActive == 12 || this.leadin.productActive == 11 || this.leadin.productActive == 3) && !brokerList.includes(this.leadin.brokerID) && this.leadin.tm == false) {


            this.isOP = true;

            this.$watch('finished', () => {
                this.finished = 1;
                //this.documentUploadText = 'Datei wurde hochgeladen'
            })


        }


        if ((this.leadin.productActive == 1 || this.leadin.productActive == 2 || this.leadin.productActive == 4 || this.leadin.productActive == 12 || this.leadin.productActive == 11 || this.leadin.productActive == 3) ){
            this.showNewHealthBlock = true
        }

        this.setRace(this.race)

        if (this.registry.cc && (this.registry.cc.includes('gat') || this.registry.cc.includes('all') || this.registry.cc.includes('marketing'))) {
            this.pushDataLayer('tierdaten', 'tierart', this.leadin.race == "1" ? "Hund" : "Katze",);

            setEntryChannel(this.leadin.breed ? 'tarifrechner' : 'produktseite');
            this.pushDataLayer('ecommerce', 'antragsstrecke_ueber', entryChannel);
        }

        if(this.leadin.petbirthday == undefined){
            this.leadin.petbirthday = new Date()
            this.leadin.petbirthday.setDate(this.leadin.petbirthday.getDate() - 56)
        }

        this.petbirthday = this.leadin.petbirthday
        this.petname = this.leadin.petname
        this.breed = this.leadin.breed
        this.race = this.leadin.race
        this.petgender = this.leadin.petgender
        this.petcolour = this.leadin.petcolour

        if(this.registry.productByID[this.leadin.productActive].coverage_DE !== '' ) {
            this.isHP = true
        }

        if ( this.leadin.productActive == 2 ) {
            this.noCat = true
        }

        if(this.race == 2 && (this.leadin.productSet == 6 || this.leadin.productSet == 5 || this.leadin.productSet == 7)) {
            this.race = "1"
            this.setRace('1')

        }
    },
    computed: {
        ageRule () {
            const rules = []
            if (this.leadin.risk_id != undefined && this.leadin.risk_id != '') { return rules }

            let max_entry_age = this.registry.productByID[this.leadin.productActive].max_entry_age

            if (max_entry_age == 0) {
                max_entry_age= 8
            }

            if(this.race == 2 && (this.leadin.productActive == 1 || this.leadin.productActive == 2)) {
                max_entry_age= 10
            }

            if (!this.petbirthday) {
                rules.push(this.rules.notEmpty)
            } else {
                var today = new Date();
                var selectedDate = new Date(this.petbirthday)
                var min_date = today.setDate(today.getDate() - (this.registry.productByID[this.leadin.productActive].min_entry_age / 3600 / 24))

                if ( min_date <  selectedDate) {
                    rules.push(this.rules.toYoung)
                }

                today = new Date();

                min_date = today.setDate(today.getDate() - (max_entry_age * 365) )
                let compare =  this.registry.productByID[this.leadin.productActive].contract_start_max - (max_entry_age * 365)

                if ( min_date >  selectedDate) {
                    if (compare == -3622){
                        rules.push(this.rules.toOldCat)
                    }
                    if (compare == -2892){
                        rules.push(this.rules.toOld)
                    }
                    if (compare == -1797){
                        rules.push(this.rules.toOld24)
                    }
                    if (compare == -7118){
                        rules.push(this.rules.toOldHP)
                    }
                }
            }

            return rules
        },
        yeartype () {
            return (this.registry.productByID[this.leadin.productActive].abbreviation.substring(0, 2) == 'HP')? 'hppet': 'pet';
        },
    },
    methods: {
        setRace (e) {
            var breeds = this.registry.dogList
            var colour = this.registry.dogColourList

            if (e == '2') {
                breeds = this.registry.catList
                colour = this.registry.catColourList
            }

            this.breed = ''
            this.petcolour = ''
            this.registry.breedList = breeds
            this.registry.colourList = colour
        },

        submitBottom() {
            if (this.$refs.petForm.validate()) {

                let matrix = this.getMatrix(this, this.registry, this.leadin.productActive);
                let seconds = this.calcAgeInSeconds(this.petbirthday)

                // 6 months
                if (puppyEntry) {
                  if (seconds > 15780000) {
                    setPuppy(false);
                  } else {
                    setPuppy(true);
                  }
                }

                let productPrice = parseFloat(this.calcPrice(matrix, seconds).toString().replace(/,/, '.'))
                if (this.leadin.race !== this.race) {
                  this.leadin.healthElements = [];
                  this.leadin.symptomElements = [];
                  this.leadin.treatmentBase = null;
                }
                this.leadin.race = this.race
                this.leadin.petbirthday = this.petbirthday
                this.leadin.petname = this.petname
                this.leadin.petcolour = this.petcolour
                this.leadin.petgender = this.petgender
                this.leadin.breed = this.breed
                this.leadin.hidden = this.hidden
                this.leadin.health = this.health
                this.leadin.chronic = this.chronic
                this.leadin.healthDescription = this.healthDescription
                this.leadin.respiratory = this.respiratory
                this.leadin.file = this.file
                this.leadin.fileInfo = this.fileInfo
                this.leadin.productPrice = productPrice
                this.$emit('leademit', this.leadin)

                // Tracking Start
              if (
                  this.registry.cc &&
                  (this.registry.cc.includes("gat") ||
                      this.registry.cc.includes("all") ||
                      this.registry.cc.includes("marketing"))
              ) {
                  try {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ecommerce: null})
                    window.dataLayer.push({
                      event: "begin_checkout",
                      ecommerce: {
                        details: {
                          currency: "EUR",
                          value: this.leadin.productPrice,
                          antragsstrecke_ueber: entryChannel,
                          pet: {
                            tierart: this.race == '1' ? "Hund" : "Katze",
                            rasse: this.breed,
                            alter: this.calculateAge(this.petbirthday),
                            geschlecht: this.petgender,
                            fellfarbe: this.petcolour,
                            rufname: this.petname,
                          }
                        },
                        items: this.getTrackingProductItems()
                      }
                    });
                  } catch (e) {
                    console.error(e);
                  }
                }
                // Tracking End

                this.$parent.advance('advancePet', true)

                return true;
            }
            else {
                document.getElementById('jumppoint').scrollIntoView();
            }
        }
    }
}



/*
- kucken wie ausgewählt markiert wird
- kucken, wie show geht

- v-bind:class="{classname:bool,classname2:bool2}""


*/

</script>
<style scoped>
.preDamage .checkbox .text {
        width:80% !important;
        padding-left:10px;
        margin-left:15px;
    }
    .form .preDamage .control {
        padding:20px;
    }
.more-margin {
    margin-bottom: 35px;
}

@media (max-width: 599px) {
    .form__group.form--large.form--unlarge {
        width:100%;
    }
}
@media (max-width: 767px) {
  .has-tooltip-icon h2 {
      display:inline-block
  }
}

.custom-file-upload{

}
input[type="file"] {
    display: none;
}

</style>
<style>
.hidefield .input-control .wrapper, .hidefield .input-control .label{
    display:none !important;
}
.hidefield .input-control .error{
    position:relative;
    top:-13px;

}
.form__section.question-list {
    margin-bottom:20px !important;
}
.form__section.question-list .form__title {
    margin-bottom: 10px;
}
.form__section.question-list .label{
    margin-left:10px;
}
.form__section.question-list .input-control.type-multiline {
    margin-top:10px !important;
    font-size:12px;
}

.form__section.question-list .input-control.type-multiline .label{
    top:5px;
    left:0px;
    font-size:12px;
}

.form__section.question-list .input-control.type-multiline + .type-pattern{
    margin-top:20px !important;
}
.input-control .control.type-pattern {
    width:46%;
    margin-left:20px;
}

.form__section.question-list .input-control.type-multiline .input textarea {
    height: 60px !important;
    font-size:12px !important;
    padding-top:15px !important;
    line-height:15px !important;
}

.form__section.question-list .input-control.type-multiline  {
    font-size:14px !important;
    top:9px;
    left:0px;
    color: #3b3b3b;

}

.form__title.less-margin{
    margin-bottom:-10px;
}
.half-control:after {
    content: "";
display:table;
  clear: both;
}
.half-control .control {
    width:29.8%;
    display:inline-box;
    float:left;
}

@media (max-width: 1439px) {
    .half-control .checkbox.control .text{
        margin-left: 0 !important
    }
}

@media (max-width: 1023px) {
    .half-control .control {
        width:48%;
    }
}

@media (max-width: 521px) {
    .half-control .control {
        width:100%;
    }
}

.form__section.question-list .input-control.half-control .type-pattern .label {
    font-size:12px !important;
    top:5px;
    left:0px;
    color: #3b3b3b;
}
.form__section.question-list .input-control.half-control .type-pattern.focused .label {
    color: #004e9e;
}
.form__section.question-list .input-control.half-control .input input {
    height: 25px !important;
    font-size:12px !important;
    padding-top:12px !important;
    line-height:12px !important;
}
.form__section.question-list .input-control.half-control .wrapper {
    padding-top:13px !important;
    margin-bottom:2px !important;
}

.form__section.question-list .input-control.focused .label, .form__section.question-list .input-control.filled .label {
  transform: translate(2px, -5px) scale(0.8, 0.8) !important;
}
#cb-dog img,
#cb-cat img {
  display: none;
}
</style>
